import React, { createContext, useContext, useEffect, useReducer, useRef } from 'react';

import { reducer, initialState, InitialState } from './reducers';

const HomepageContext = createContext<{ [key: string]: any }>(initialState);

function useEnhanceReducer(
  reducer,
  initialState: React.ReducerState<any>
): [React.ReducerState<any>, React.Dispatch<React.ReducerAction<any>>] {
  const [store, dispatch]: [React.ReducerState<any>, React.Dispatch<React.ReducerAction<any>>] = useReducer(
    reducer,
    initialState
  );

  const storeRef = useRef<InitialState>(store);
  useEffect(() => {
    storeRef.current = store;
  }, [store]);

  const getStore = () => {
    return { ...storeRef.current };
  };

  const enhanceDispatch = action => {
    if (typeof action === 'function') {
      return action(enhanceDispatch, getStore);
    } else if (action.payload instanceof Promise) {
      return action.payload
        .then(data => {
          const res = data?.object;
          enhanceDispatch({ ...action, payload: res });
          if (typeof action.callback === 'function') {
            action.callback(null, res);
          }
        })
        .catch(err => {
          if (typeof action.callback === 'function') {
            action.callback(err);
          }
        });
    } else {
      return dispatch(action);
    }
  };
  return [store, enhanceDispatch];
}

export const HomepageProvider = ({ children, data }) => {
  const [store, dispatch] = useEnhanceReducer(reducer, { ...initialState, ...data });
  return <HomepageContext.Provider value={{ store, dispatch }}>{children}</HomepageContext.Provider>;
};

export const HomepageDrawerCompatibleProvider = ({ children, data }) => {
  const [store, dispatch] = useEnhanceReducer(reducer, { ...initialState, ...data });
  return <HomepageContext.Provider value={{ store, dispatch }}>{children}</HomepageContext.Provider>;
};

type ActionType = {
  type: string;
  payload: Promise<any> | any;
  callback?: (errorInfo?: any, responseData?: any) => void;
};

type UseHomepageType = {
  store: InitialState;
  dispatch: (action: ActionType) => void;
  [key: string]: any;
};

export default function useHomepage(): UseHomepageType {
  return useContext(HomepageContext) as UseHomepageType;
}
